import { Component, Input } from '@angular/core';
import { reportTitals } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-report-categories-definition',
  templateUrl: './report-categories-definition.component.html',
  styleUrls: ['./report-categories-definition.component.scss'],
})
export class ReportCategoriesDefinitionComponent {
  reportResource = reportTitals;
  @Input() isCheckISO: boolean = false;
  @Input() indicatorList: any = [];
}
